module.exports = __webpack_public_path__ + "img/2e.4b466375.png";